import { useEffect, useState } from 'react'

import { FC, invalidateQuery, useCQuery } from '../../../../Services'
import { showToast } from '../../../../utils/toast'

export const useSociety = (societyId) => {
  const [society, setSociety] = useState()
  const { data, isSuccess } = useCQuery(['environment', societyId])

  useEffect(() => {
    isSuccess && setSociety(data)
  }, [isSuccess, data])

  const setSocietyProp = (prop, value) => setSociety({ ...society, [prop]: value })

  return [society, setSocietyProp, isSuccess]
}

export const saveSociety = async (society) => {
  try {
    if (society.id === 'new') {
      delete society.id
      const res = await FC.service('environments').create(society)
      invalidateQuery(['environment', 'environments'])
      showToast('success', 'Success', 'Salvataggio effettuato')
      return res
    }
    const res = await FC.service('environments').patch(society.id, society)
    invalidateQuery(['environment', 'environments'])
    showToast('success', 'Success', 'Salvataggio effettuato')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || 'Errore durante il salvataggio')
    return false
  }
}

export const deleteSociety = async (societyId) => {
  try {
    const res = await FC.service('environments').remove(societyId)
    invalidateQuery(['environment', 'environments'])
    showToast('success', 'Success', 'Eliminazione effettuata')
    return res
  } catch (error) {
    showToast('error', 'Errore', error?.message || "Errore durante l'eliminazione")
    return false
  }
}
